import React from 'react';

interface ChartContainerProps {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  /** Rendered in the top-right corner — designed for TimeRangeFilter */
  topRightElement?: React.ReactNode;
  subtitle?: React.ReactNode;
  isLoading?: boolean;
  className?: string;
}

const ChartContainer: React.FC<ChartContainerProps> = ({
  title,
  children,
  actions,
  topRightElement,
  subtitle,
  isLoading = false,
  className = ''
}) => {
  return (
    <div className={`glass rounded-lg shadow-sm hover:shadow-md transition-all duration-300 ${className}`}>
      <div className="flex items-center justify-between mb-6 px-6 pt-6">
        <div className="space-y-1 min-w-0">
          <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">{title}</h3>
          {subtitle && (
            <div className="mt-0.5">{subtitle}</div>
          )}
        </div>
        <div className="flex items-center gap-2 flex-shrink-0 ml-3">
          {topRightElement}
          {actions}
        </div>
      </div>
      <div className="relative px-6 pb-6">
        {isLoading ? (
          <div className="h-64 flex items-center justify-center animate-fadePulse">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full animate-fadePulse"></div>
              <span className="text-gray-600 dark:text-gray-400">{`Loading chart data...`}</span>
            </div>
          </div>
        ) : (
          <div className="relative">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChartContainer;